import React from 'react';

import { Alert, Button, Group, LoadingOverlay, Modal, Stack, Text, Title } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import useDeletePayrollPeriod from 'hooks/payrollPeriod/useDeletePayrollPeriod';
import notificationHandler from 'utils/notifications';

interface IModalPayrollPeriodDelete {
  opened: boolean;
  handleClose: () => void;
  payrollPeriodId?: string;
  clearPayrollPeriod: () => void;
}

const ModalPayrollPeriodDelete = ({
  opened,
  payrollPeriodId,
  clearPayrollPeriod,
  handleClose,
}: IModalPayrollPeriodDelete): JSX.Element => {
  const deleteMutation = useDeletePayrollPeriod();

  const { successNotification, errorNotification } = notificationHandler();
  const handleDelete = (): void => {
    if (payrollPeriodId) {
      deleteMutation.mutate(payrollPeriodId, {
        onSuccess: () => {
          successNotification('Payroll period delete success');
          clearPayrollPeriod();
          handleClose();
        },
        onError: error => {
          errorNotification('Payroll period delete failed', error.response?.data.message);
        },
      });
    }
  };
  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Delete Payroll Period</Title>}
      size='auto'
    >
      <LoadingOverlay visible={!payrollPeriodId} />
      <Stack>
        <Text>{`Are you sure you want to delete this payroll period?`}</Text>
        <Alert variant='light' color='yellow' title='Attention' icon={<IconInfoCircle />}>
          Deleting this payroll period will remove all related data permanently.
        </Alert>
        <Group position='right'>
          <Button
            variant='light'
            onClick={handleClose}
            size='xs'
            radius='md'
            disabled={deleteMutation.isLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            color='red'
            loading={deleteMutation.isLoading}
            data-cy='deletePayrollPeriodButtonSubmit'
          >
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalPayrollPeriodDelete;
